/**
 * 本地存储封装
 * 统一管理 localStorage / sessionStorage，支持命名空间与过期时间
 */
class StorageHelper {
  private storage: globalThis.Storage

  constructor(storage: globalThis.Storage = localStorage) {
    this.storage = storage
  }

  /**
   * 设置缓存
   * @param key 键
   * @param value 值
   * @param expire 过期时间（毫秒），不传则永久有效
   */
  set<T>(key: string, value: T, expire?: number): void {
    const data = {
      value,
      expire: expire ? Date.now() + expire : null
    }
    this.storage.setItem(key, JSON.stringify(data))
  }

  /**
   * 读取缓存，若已过期则自动清除并返回 null
   */
  get<T>(key: string): T | null {
    const raw = this.storage.getItem(key)
    if (!raw) return null

    try {
      const data = JSON.parse(raw)
      // 不带 expire 结构的旧数据，直接返回
      if (data && typeof data === 'object' && 'value' in data) {
        if (data.expire && Date.now() > data.expire) {
          this.remove(key)
          return null
        }
        return data.value as T
      }
      return data as T
    } catch {
      return raw as unknown as T
    }
  }

  remove(key: string): void {
    this.storage.removeItem(key)
  }

  clear(): void {
    this.storage.clear()
  }
}

export const localStore = new StorageHelper(localStorage)
export const sessionStore = new StorageHelper(sessionStorage)

export default localStore
